import React, { useEffect, useState } from "react";
import Message from "../messages/message";
import { ToggleSwitch } from "../form/toggleSwitch";
import { Tooltip } from 'react-tooltip';
import Button from "../button/button";
import { styled } from "styled-components";
import ErrorMessage from "../messages/error";
import emailIcon from '../../assets/icon/email.svg';
import fullNameIcon from '../../assets/icon/user.svg';
import useUserStore from "../../data/store/useUserStore";
import { t } from 'ttag';

const Disclose = styled.div`  
  padding: 13px 20px 1px;
  border-radius: 10px;
  background: #F5F5F5;
  width: 240px;
  text-align: center;
  label {
    float: left;
  }
  p {
    padding-top: 4px;
  }
`;

const Section = styled.section`
  .termsBlock {
    display: flex;
    
    input[type="checkbox"] {
      margin-right: 10px;
    }
    
    p {
      margin: 0;
      padding-left: 5px;
      padding-right: 5px;
    }
    
    a {
      color: #9738FF;
      margin-left: 5px;
    }
  }
  .form {
    .personalEmail {
      span {
        background: #6F6F6F;
        color: #FFF;
        border-radius: 25px;
        margin-left: 10px;
        padding: 2px 9px;
        width: 24px;
        height: 24px;
        position: absolute;
        margin-top: -3px;
        font-weight: 800;
      }
    }
    label {
      display: block;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      padding-bottom: 5px;
    }
    input {
      border: 0px solid;
      border-radius: 5px;
      background: #F5F5F5;
      padding: 10px 20px;
      padding-left: 40px;
      width: 100%;
      margin-bottom: 5px;
    }
    .fullNameIcon {
      position: absolute;
      &::before {
        content: '';
        width: 30px;
        height: 30px;
        position: absolute;
        margin-top: 8px;
        margin-left: 10px;
        background-image: url(${fullNameIcon});
        background-repeat: no-repeat;
      }
    }
    .emailIcon {
      position: absolute;
      &::before {
        content: '';
        width: 30px;
        height: 30px;
        position: absolute;
        margin-top: 8px;
        margin-left: 10px;
        background-image: url(${emailIcon});
        background-repeat: no-repeat;
      }
    }
  }
  
  @media (max-width: 768px) {
    .row {
      width: 100%;
      margin: 0px;
    }
    .col-5 {
      width: 100%;
      button {
        width: 100%;
      }
    }
    .discloseBlock {
      div {
        width: 100%;
      }
    }
    .form {
      .col-6 {
        width: 100%;
        margin-bottom: 14px;
      }
    }
  }
`;

const BeforeYouGo = ({ onSubmit }) => {
  const { setUserInfo, email, fullName } = useUserStore();

  const [ personal, setPersonal ] = useState((fullName && email) ? true : false);
  const [formData, setFormData] = useState({ fullName: fullName, email: email });
  const [emailError, setEmailError] = useState('');
  const [fullNameError, setFullNameError] = useState('');
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (personal) {
      if (!formData.fullName || !formData.email) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    } else {
      setDisabled(false);
    }
  }, [personal, formData]);

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return re.test(email);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmitFeedback = () => {
    if (personal) {

      let weCanSaveData = true;

      if (!formData.fullName) {
        weCanSaveData = false;
        setFullNameError(t`Please enter a Full name`);
      } else {
        setFullNameError('');
      }

      if (validateEmail(formData.email)) {
        setEmailError('');
      } else {
        weCanSaveData = false;
        setEmailError(t`Please enter a valid email address.`);
      }

      if (weCanSaveData) {
        setUserInfo({
          email: formData.email,
          fullName: formData.fullName,
          terms: true
        });

        if (onSubmit) {
          onSubmit();
        }
      }
    } else {
      setUserInfo({
        email: '',
        fullName: '',
        terms: true
      });

      if (onSubmit) {
        onSubmit();
      }
    }
  };

  return <Section>
    <h2>{t`Before You Go`}</h2>
    <div className='row mt-2'>
      <Message type={!personal ? 'success' : 'warning'}>
        {!personal ? t`Your case will be submitted Anonymously` : t`Your case will NOT be submitted anonymously`}
      </Message>
      <p className='mt-2'>{t`OPTIONAL: Provide your personal information`}</p>
      <p className='mt-2'><b>{t`Would you like to disclose your personal information?`}</b></p>
      <div className='mt-2 discloseBlock'>
        <Disclose>
          <ToggleSwitch
            id="disclose"
            name="disclose"
            value={personal ? t`On` : t`Off`}
            checked={personal}
            onChange={() => setPersonal(!personal)}
          />
          <p>{!personal ? t`Yes, disclose` : t`No, do not disclose`}</p>
        </Disclose>
      </div>
      {personal && (
        <div>
          <div className='row mt-4 form'>
            <div className='col-6'>
              <label htmlFor="fullNameInput">{t`Full name`}</label>
              <i className='fullNameIcon'></i>
              <input
                id="fullNameInput"
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
              />
              {fullNameError && <ErrorMessage text={fullNameError} />}
            </div>
            <div className='col-6'>
              <label htmlFor="emailInput" className='personalEmail'>{t`Personal email address`}
                <span
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={t`We suggest the use of a personal email account.`}
                >?</span>
                <Tooltip id="my-tooltip" />
              </label>
              <i className='emailIcon'></i>
              <input
                id="emailInput"
                type="text"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {emailError && <ErrorMessage text={emailError} />}
            </div>
          </div>
        </div>
      )}
      <div className='row mt-4'>
        <div className='col-5'>
          <Button title={t`Submit Feedback`} onClick={onSubmitFeedback} disabled={disabled} />
        </div>
      </div>
    </div>
  </Section>
};

export default BeforeYouGo;
